export default __webpack_public_path__ + "static/epica-1-33019f9f98b0c05c71147c9706e8bcd7.jpg";